import { render } from "./productCartSummary.vue?vue&type=template&id=e2541440"
import script from "./productCartSummary.vue?vue&type=script&lang=js"
export * from "./productCartSummary.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__